export function addConnectorsToList(languages: string[]): string | undefined {
  if (languages.length === 0) {
    return undefined
  }

  const lastElement = languages[languages.length - 1]
  let separator = t('lang.connectors.addition')

  separator = lastElement[0].toLowerCase() !== 'i' ? 'y' : 'e'
  if (languages.length > 2) {
    const firstElements = languages.slice(0, -1).join(', ')
    return `${firstElements} ${separator} ${lastElement}`
  } else {
    return languages.join(` ${separator} `)
  }
}
